module.exports = __webpack_public_path__ + "img/Beginner-3.b340e082.png";